export const ACCESS_DURATION_OPTIONS = [
  { label: '5 minutes', value: 5 },
  { label: '10 minutes', value: 10 },
  { label: '15 minutes', value: 15 },
  { label: '30 minutes', value: 30 },
  { label: '1 hour', value: 60 },
  { label: '2 hours', value: 120 },
  { label: '4 hours', value: 240 },
  { label: '8 hours', value: 480 },
  { label: '12 hours', value: 720 },
  { label: '24 hours', value: 1440 },
];

export const DEFAULT_ACCESS_DURATION_MINUTES = 10;

export const ACCESS_DURATION_VALUES = ACCESS_DURATION_OPTIONS.map((o) => o.value);

export const formatAccessDurationLabel = (minutes) => {
  const value = Number(minutes);
  if (!Number.isFinite(value) || value <= 0) return '';
  const match = ACCESS_DURATION_OPTIONS.find((o) => o.value === value);
  if (match) return match.label;
  if (value < 60) return `${value} minutes`;
  if (value === 60) return '1 hour';
  if (value % 60 === 0) return `${value / 60} hours`;
  return `${value} minutes`;
};
